




































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { ProfileState, User } from '@/store/profile/types';
import { Wallet } from '@/store/wallet/types';
import { BankAccount, MangoPayMandates } from '@/store/mangoPay/types';
import { centsToEuro } from '@/filters/currency';
import { date } from '@/filters/date';
import Modal from '@/components/_common/Modal.vue';
import BankAccountListSelector from '@/components/bankAccount/shared/BankAccountListSelector.vue';
import { KycStatus } from '@/enum/mangoPay/KycTypes';

const namespace: string = 'profile';

@Component({
  name: 'withdraw-wallet',
  components: {
    Modal,
    BankAccountListSelector,
  },
  filters: {
    centsToEuro,
    date,
  },
})
export default class WithdrawWallet extends Vue {
  @Prop({ required: true }) wallet: Wallet;
  @Prop({ required: true }) user: User;
  @Prop({ required: true }) bankAccounts: Array<BankAccount>;
  @Prop({ required: true }) mandates: MangoPayMandates;

  @Action('wallet/createPayOut') createPayOut: Function;

  private paymentType: string = 'SEPA_TRANSFER';
  private withdrawAmount: number = null;
  private selectedBankAccount: string = null
  private error: boolean = false;
  private resultMessage: string = '';
  private isLoading: boolean = false;

  mounted() {
    this.checkBankAccounts();
  }

  @Watch('bankAccounts')
  onPropertyChanged(value: Array<BankAccount>) {
    this.checkBankAccounts();
  }

  get invalidIdent() {
    return !this.user.kyc_completed_at;
  }

  get lockedAccount() {
    return !!this.user.locked_at;
  }

  get blockedUI() {
    return this.invalidIdent || this.lockedAccount;
  }

  get identMessage() {
    let message = '';
    // translation keys context
    let context = '';
    switch (this.user.kyc_doc_status) {
      case KycStatus.VALIDATION_ASKED:
        context = 'updating';
        break;
      default:
        context = 'create';
    }

    message += `<p>${this.$t('ident.label', { context })}</p>`;
    message += this.$t('ident.cta', {
      context,
      link: `<a target='_blank' href='${this.identURL}'>
          ${this.$t('ident.linkTitle')}</a>`,
    });

    return message;
  }

  get identURL() {
    return `${process.env.VUE_APP_EXPORO_USER_URL}#/onboarding/ident`;
  }

  get hasResultMessage() {
    return this.resultMessage != '';
  }

  get balance() {
    return this.wallet ? this.wallet.Balance.Amount : 0;
  }

  get hasBankAccount() {
    return this.bankAccounts && this.bankAccounts.length > 0;
  }

  get canSubmit() {
    return this.withdrawAmount && this.withdrawAmount > 0 && this.selectedBankAccount && !this.isLoading && !this.blockedUI;
  }

  checkBankAccounts() {
    if (this.bankAccounts && this.bankAccounts.length === 1) {
      this.onBankSelect(this.bankAccounts[ 0 ].Id);
    }
  }

  onBankSelect(bankAccountId: string) {
    this.selectedBankAccount = bankAccountId;

    const bankAccount = this.bankAccounts.find(account => account.Id === this.selectedBankAccount);
    this.error = false;
    this.resultMessage = '';
    if (!bankAccount.Active) {
      this.error = true;
      this.resultMessage = this.$t('withdrawWalletModal.error', {
        context: 'disabled',
      });
    }
  }

  onSubmit() {

    const payload = {
      amount: parseInt((this.withdrawAmount * 100).toFixed()), 
      bankAccountId: this.selectedBankAccount,
    };

    this.isLoading = true;

    this.createPayOut(payload)
      .then((response) => {
        this.$router.push('/');
      }).catch((err) => {
        this.error = true;
        this.resultMessage = this.$t('forms.error', { context: 'generic' });
        // ewallet service validations
        if(err.response.status === 422 && err.response.data[0]) {
          const validationError = err.response.data[0].type.split('.').pop();

          if(validationError === 'min'){
            this.resultMessage = this.$t('withdrawWalletModal.error', { context: validationError });
          }
        }
        })
      .finally(() => this.isLoading = false);
  }

  onClose() {
    this.error = false;
    this.resultMessage = '';
  }
}
